export default __webpack_public_path__ + "static/media/announcement.7421c811.svg";